import { useApplicationContext } from '@css-xp/base';
import { BillingFrequency, CycleInterval } from '@css-xp/graphtypes/src/generated-types-new';
import { getPartnerPromotions } from '@atlassian/temp-proxies';

export type UsePartnerPromotionDetailsHookType = (
  txaId: string,
  billingFrequency: string,
  productKeys: {
    productKey: string;
    isApp: boolean;
  }[]
) => {
  getPromotions: () => Promise<Record<string, string | undefined>>;
};

export const usePartnerPromotionDetails: UsePartnerPromotionDetailsHookType = (
  txaId,
  billingFrequency,
  productKeys
) => {
  const userData = useApplicationContext();
  const selectedPartnerAccountData = userData?.partnerAccounts?.find(
    ({ transactionAccountId }: { transactionAccountId: string }) => transactionAccountId === txaId
  );

  const getPromotions = async (): Promise<Record<string, string | undefined>> => {
    const responses = await Promise.all(
      productKeys.map((productInfo) => {
        return getPartnerPromotions({
          productKeys: [productInfo.productKey],
          pricingType: 'PAID',
          cycleInterval: billingFrequency === BillingFrequency.MONTHLY ? CycleInterval.MONTH : CycleInterval.YEAR,
          partnerStatus: {
            discountTier: selectedPartnerAccountData?.discountTier,
            programLevelGlobal: selectedPartnerAccountData?.programLevelGlobal,
          },
          ...(productInfo.isApp && {
            offeringRelationship: [
              {
                direction: 'TO',
                type: 'APP_DEPENDENCE',
              },
            ],
          }),
        });
      })
    );
    const map: Record<string, string | undefined> = {};
    for (let count = 0; count < productKeys.length; count++) {
      const availablePromotionIds = responses?.[count]?.availablePromotion?.['ACTIVE'];
      if (availablePromotionIds?.length && availablePromotionIds?.length > 1) {
        throw new Error('Multiple promotions are available.');
      }
      map[productKeys[count]['productKey']] = availablePromotionIds?.[0];
    }
    return map;
  };

  return {
    getPromotions,
  };
};
